import { GridLayout } from "~/components/GridLayout";
import { ItemSkeleton } from "~/components/ItemSkeleton";
import { useDisplayProducts } from "~/providers/store/basket/hooks/use-display-products";
import { useBasketContext } from "~/providers/store/basket/context";

import { ProductItem } from "./product-item";

export const ProductsGrid = () => {
  const productsStatus = useBasketContext((state) => state.productsStatus);

  if (productsStatus !== "success") {
    return (
      <GridLayout>
        {Array.from({ length: 20 }).map((_, index) => (
          // eslint-disable-next-line react/no-array-index-key -- fixed-length skeleton list
          <ItemSkeleton key={index} />
        ))}
      </GridLayout>
    );
  }

  return <Products />;
};

const Products = () => {
  const displayProducts = useDisplayProducts();

  return (
    <GridLayout>
      {displayProducts.map((product) => (
        <ProductItem
          disabled={product.disabled}
          key={product.id}
          product={product}
          unitSystem={product.unitSystem}
        />
      ))}
    </GridLayout>
  );
};
